"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subtopic = void 0;
var Subtopic;
(function (Subtopic) {
    Subtopic["EducationPlanning"] = "education-planning";
    Subtopic["FamilyAndEstate"] = "family-and-estate";
    Subtopic["HealthAndInsurance"] = "health-and-insurance";
    Subtopic["Investing"] = "investing";
    Subtopic["PersonalFinance"] = "personal-finance";
    Subtopic["Retirement"] = "retirement";
    Subtopic["Taxes"] = "taxes";
})(Subtopic || (exports.Subtopic = Subtopic = {}));
